import React from 'react'
import PropTypes from 'prop-types'
import SkeletonOverviewOnTour from '../../../../components/OverviewOnTour/skeleton'
import OverviewOnTour from '../../../../components/OverviewOnTour'
import ErrorBoundary from '../../../../../Error/widgets/ErrorBoundary'
import MessageError from '../../../../../Error/screens/MessageError'
import translate from '../../../../../../modules/translate'

const errorOptions = {
  component: translate('galleries'),
  link: '/',
  linkText: translate('error_try_homepage'),
  logError: 'OnTour screen display',
}

const ScreenOnTourOverview = ({ response: { data }, loading, error, ready, match, ...props }) => (
  <ErrorBoundary {...errorOptions} {...props}>
    {error && <MessageError logInfo={error.message} {...errorOptions} />}
    {loading && <SkeletonOverviewOnTour />}
    {data && <OverviewOnTour data={data} />}
  </ErrorBoundary>
)

ScreenOnTourOverview.propTypes = {
  response: PropTypes.shape({
    meta: PropTypes.object,
    data: PropTypes.object,
  }),
  loading: PropTypes.bool,
  error: PropTypes.object,
  ready: PropTypes.bool,
  match: PropTypes.object,
}

ScreenOnTourOverview.defaultProps = {
  response: {
    data: undefined,
  },
}

export default ScreenOnTourOverview
